import { BRAND_LOGO } from '@/app/theme-tokens';

interface Props {
  size?: number;
  /** Có ô nền bo góc (thanh bên, trang đăng nhập) hay để trần trên nền sẵn có. */
  tile?: boolean;
}

/**
 * Logo DỰ ÁN SUN MUSIC (06/10/2026) — mặt trời mọc trên hai vạch sóng, vẽ bằng SVG (`public/logo-sun.svg`)
 * nên sắc nét ở mọi cỡ. Ảnh có sẵn nền bo góc cùng màu `BRAND_LOGO.tile`; ô nền của thẻ để cùng màu cho mép
 * ảnh không lộ khung. Chưa có logo thật của dự án — khi chủ dự án gửi ảnh thì thay file này (và chạy lại
 * `scripts/make-brand-icons.mjs` cho PNG của PWA / iPhone). Trước đó là ảnh thật của HALO RECORDS.
 */
export function BrandMark({ size = 34, tile = true }: Props) {
  return (
    <img
      src="/logo-sun.svg"
      alt="SUN MUSIC"
      width={size}
      height={size}
      style={{
        flex: 'none',
        display: 'block',
        borderRadius: tile ? size * 0.22 : 0,
        background: tile ? BRAND_LOGO.tile : undefined,
        objectFit: 'cover',
      }}
    />
  );
}
